import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index'
import About from '@/pages/about'
import Artist from '@/pages/artist'
import ArtistInfo from '@/pages/artist-info'
import BiasFxMobile from '@/pages/bias-fx-mobile'
import BiasFxMobileSpec from '@/pages/bias-fx-mobile-spec'
import BiasFx2 from '@/pages/bias-fx2'
import BiasFx2Feature from '@/pages/bias-fx2-feature'
import BiasFx2Spec from '@/pages/bias-fx2-spec'
import BiasFx2Coupon from '@/pages/bias-fx2-coupon'
import Support from '@/pages/support'
import BiasMiniGuitar from '@/pages/bias-mini-guitar'
import BiasMiniGuitarSound from '@/pages/bias-mini-guitar-sound'
import BiasMiniGuitarSpec from '@/pages/bias-mini-guitar-spec'
import AppMonFx2 from '@/pages/app-mon-fx2'
import DownloadPage from '@/pages/download'
import SparkPage from '@/pages/spark'
import SparkPage40 from '@/pages/spark40'
import SparkMiniPage from '@/pages/spark-mini'
import SparkLivePage from '@/pages/spark-live'
import SparkNeoPage from '@/pages/spark-neo'
import SparkEdgePage from '@/pages/spark-edge'
import SparkGoPage from '@/pages/spark-go'
import Spark2 from '@/pages/spark2'
import HelpCenter from '@/pages/helpCenter/help-center'
import HelpCenterDetail from '@/pages/helpCenter/help-center-detail'
import Redeem from '@/pages/redeem'
import riffInterface from '@/pages/riff_interface'

Vue.use(Router)

export default new Router({
  scrollBehavior: function (to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  },
  mode: 'history',
  routes: [
    {
      path: '*',
      component: Index
    },
    {
      path: '/',
      name: 'Index',
      component: Index,
      beforeEnter: (to, from, next) => {
        if (to.fullPath.substr(0, 2) === '/#') {
          const path = to.fullPath.substr(2)
          next(path)
          return
        }
        next()
      }
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/artist',
      name: 'Artist',
      component: Artist
    },

    {
      path: '/artist/:name',
      name: 'ArtistInfo',
      component: ArtistInfo
    },
    {
      path: '/bias-fx-mobile',
      name: 'BiasFxMobile',
      component: BiasFxMobile
    },
    {
      path: '/bias-fx-mobile/spec',
      name: 'BiasFxMobileSpec',
      component: BiasFxMobileSpec
    },
    {
      path: '/bias-fx2',
      name: 'BiasFx2',
      component: BiasFx2
    },
    {
      path: '/bias-fx2/feature',
      name: 'BiasFx2Feature',
      component: BiasFx2Feature
    },
    {
      path: '/bias-fx2/spec',
      name: 'BiasFx2Spec',
      component: BiasFx2Spec
    },
    {
      path: '/support',
      name: 'Support',
      component: Support
    },
    {
      path: '/bias-fx2-coupon',
      name: 'BiasFx2Coupon',
      component: BiasFx2Coupon
    },
    {
      path: '/bias-mini-guitar',
      name: 'BiasMiniGuitar',
      component: BiasMiniGuitar
    },
    {
      path: '/bias-mini-guitar/sound',
      name: 'BiasMiniGuitarSound',
      component: BiasMiniGuitarSound
    },
    {
      path: '/bias-mini-guitar/spec',
      name: 'BiasMiniGuitarSpec',
      component: BiasMiniGuitarSpec
    },
    {
      path: '/iap-cta-fx2',
      name: 'AppMonFx2',
      component: AppMonFx2
    },
    {
      path: '/download',
      name: 'Download',
      component: DownloadPage
    },
    {
      path: '/spark',
      name: 'Spark',
      component: SparkPage
    },
    {
      path: '/spark40',
      name: 'Spark40',
      component: SparkPage40
    },
    {
      path: '/spark-mini',
      name: 'SparkMini',
      component: SparkMiniPage
    },
    {
      path: '/spark-live',
      name: 'SparkLive',
      component: SparkLivePage
    },
    {
      path: '/spark-edge',
      name: 'SparkNeo',
      component: SparkEdgePage
    },
    {
      path: '/spark-neo',
      name: 'SparkNeo',
      component: SparkNeoPage
    },
    {
      path: '/spark-go',
      name: 'SparkGo',
      component: SparkGoPage
    },
    {
      path: '/spark2',
      name: 'Spark2',
      component: Spark2
    },
    {
      path: '/spark/specs',
      name: 'SparkSpecs',
      component: SparkPage
    },
    {
      path: '/help-center',
      name: 'HelpCenter',
      component: HelpCenter
    },
    {
      path: '/help-center-detail',
      name: 'HelpCenterDetail',
      component: HelpCenterDetail
    },
    {
      path: '/redeem',
      name: 'Redeem',
      component: Redeem
    },
    {
      path: '/riff_interface',
      name: 'riff_interface',
      component: riffInterface
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js